import { composeIO } from 'react-compose-io'
import { modalNovoCicloIO } from './ModalNovoCiclo.IO'
import ModalNovoCicloView from './ModalNovoCiclo.View'

export const ModalNovoCiclo = composeIO(ModalNovoCicloView, modalNovoCicloIO)
